// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"e35c2e92","84":"1882a3b1","247":"32555226","488":"b78afbdf","627":"055b4357","834":"460d515a","867":"62152878","923":"2e6960ba"}[chunkId] + ".chunk.js";
};